import Reflux from 'reflux';
import EventFileSystemObjectData from 'shared/data/EventFileSystemObject';

let async = { asyncResult: true };
let EventFolderSearchInputActions = Reflux.createActions({
  setTerm: {},
  toggleVisibility: {},
  search: async,
  moveSelectionUp: {},
  moveSelectionDown: {},
});

EventFolderSearchInputActions.search.listenAndPromise(
  EventFileSystemObjectData.search,
);

export default EventFolderSearchInputActions;
